<template>
  <div v-if="showModalFilterV2" class="modal modal--full-fixed modal-filter-search hide-desktop">
    <div slot="body" class="full-height">
      <div class="modal-body">
        <template v-if="seeAllBrands">
          <div class="modal-header">
            <h5 class="modal-heading">Brands</h5>
            <a href="" class="modal-dismiss" @click.prevent="(seeAllBrands = false), (brandSearch = '')">
              <i class="icon_close"></i>
            </a>
          </div>
          <div class="section section--brands showing-all-brands filter-group--by-brand">
            <ul
              v-if="
                $route.name === 'Category' ||
                $route.name === 'Search' ||
                $route.name == 'OurCuratedSelections' ||
                $route.name == 'ProductMatchCategory'
              "
              class="tabs tabs-brand"
            >
              <li :class="{ active: activeTab === 0 }">
                <a href="" title="Brand Name" @click.prevent="activeTab = 0">Brand Name</a>
              </li>
              <li :class="{ active: activeTab === 1 }">
                <a href="" title="Brand Origins" @click.prevent="activeTab = 1">Brand Origins</a>
              </li>
            </ul>
            <div class="section-brand-wrapper">
              <div class="search-with-icon">
                <input
                  ref="typeBrand"
                  v-model="brandSearch"
                  type="text"
                  name="search"
                  class="form-control search-with-icon__input"
                  placeholder="Search brand..."
                  @focus="onFocusShowAllBrands()"
                />
              </div>

              <ul v-if="listSelectedBrand.active.length" class="list-inline list-scrollable list-active-brand">
                <li v-for="(brand, key) in listSelectedBrand.active" :key="key">
                  <a href="javascript:0" class="pill">
                    {{ activeTab === 0 ? brand.name : brand.country }}
                    <span class="pill-dismiss" @click.prevent="removeSelectedBrand(key, activeTab)"></span>
                  </a>
                </li>
              </ul>

              <ul :class="{ expand: listSelectedBrand.length }" class="list-scrollable list-scrollable--letters">
                <li
                  v-for="(letter, key) in letters"
                  :key="`brand-${key}`"
                  :class="{
                    active: letter.isActive,
                    selected: letter.isActive && key === clickedBrand,
                  }"
                >
                  <a @click.prevent="() => (letter.isActive ? scrollToBrandMenu('brand-' + key) : null)">
                    {{ key }}
                  </a>
                </li>
              </ul>

              <div class="side-checkbox" :class="{ 'selected-height': filteredBrands.length }">
                <p v-if="isEmptyWhenTypingBrand" class="empty-typing-brand">No results found</p>
                <ul v-if="filteredBrands.length" id="brand-list-by-filter">
                  <li
                    v-for="(brand, key) in filteredBrands"
                    :id="buildIdElBrand(brand, key)"
                    :key="key"
                    :class="[{ hidden: brand.isHidden }, 'for-br-' + brand.name[0].toLowerCase()]"
                  >
                    <input
                      v-if="activeTab === 0"
                      :id="'filterbrand-' + brand._id"
                      v-model="selectedBrand"
                      type="checkbox"
                      :value="brand._id"
                      name="filterbrand_mobile"
                      class="checkbox"
                    />
                    <input
                      v-else
                      :id="'filterbrand-' + brand._id"
                      v-model="selectedOrigin"
                      type="checkbox"
                      :value="brand.country_tag_id"
                      name="filterbrand_mobile"
                      class="checkbox"
                    />
                    <label :for="'filterbrand-' + brand._id">
                      <img
                        v-if="activeTab === 1 && brand.flag"
                        :src="brand.flag"
                        width="20"
                        height="14"
                        :alt="brand.country"
                        class="flag-brand"
                      />
                      {{ activeTab === 0 ? brand.name : brand.country }}
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="modal-header">
            <h5 class="modal-heading">Filter</h5>
            <a href="" class="modal-dismiss" @click.prevent="closeModal">
              <i class="icon_close"></i>
            </a>
          </div>

          <!-- <FilterByBeautyProfile
            v-if="isProductMatchCategory && beautyProfile.length"
            ref="beauty"
            :list="beautyProfile"
            @selected="selectedBeauty"
          /> -->
          <div v-if="options.available" class="section section--brands filter-group filter-group--by-brand">
            <h5 class="section__heading">Availibility</h5>

            <ul class="list">
              <li v-for="(avail, idx) in availibility" :key="idx" class="list__item">
                <input
                  :id="avail"
                  v-model="filterAvailChecked"
                  type="checkbox"
                  name="filter_brand_desktop"
                  :value="avail"
                  class="checkbox"
                />
                <label>{{ availabitiesLabel(avail) }}</label>
              </li>
            </ul>
          </div>
          <div v-if="options.brands" class="section section--brands filter-group--by-brand">
            <h5 class="section__heading">
              Brands
              <a href="" @click.prevent="seeAllBrands = true">Lihat Semua</a>
            </h5>
            <div class="section-brand-wrapper">
              <div class="search-with-icon">
                <input
                  type="text"
                  name="search"
                  class="form-control search-with-icon__input"
                  placeholder="Search brand..."
                  @keyup="onKeyupSearchbrand"
                  @focus="onFocusShowAllBrands"
                  @click.prevent="seeAllBrands = true"
                />
              </div>
              <template v-if="listSelectedBrand.brand.length">
                <p class="section__heading">Brand names :</p>
                <ul class="list-inline list-scrollable list-active-brand">
                  <li v-for="(brand, key) in listSelectedBrand.brand" :key="key">
                    <a href="javascript:0" class="pill">
                      {{ brand.name }}
                      <span class="pill-dismiss" @click.prevent="removeSelectedBrand(key, 0)"></span>
                    </a>
                  </li>
                </ul>
              </template>
              <template v-if="listSelectedBrand.origin.length">
                <p class="section__heading">Brand origins :</p>
                <ul class="list-inline list-scrollable list-active-brand">
                  <li v-for="(brand, key) in listSelectedBrand.origin" :key="key">
                    <a href="javascript:0" class="pill">
                      {{ brand.country }}
                      <span class="pill-dismiss" @click.prevent="removeSelectedBrand(key, 1)"></span>
                    </a>
                  </li>
                </ul>
              </template>
              <ul v-if="list_country && list_country.length" class="list-inline list-active-brand list-temp">
                <li v-for="(brand, key) in list_country.slice(0, 5)" :key="key">
                  <a href="javascript:0;" class="pill" @click.prevent="setSelectedOrigin(brand)">
                    {{ brand.country }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="options.rating" class="section section--price">
            <h5 class="section__heading">Ratings</h5>
            <ul class="list">
              <li class="list__item">
                <input id="rating_5" v-model="filterRating" type="radio" name="rating_desktop" value="5" />
                <label for="rating_5" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-50">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">5</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_4" v-model="filterRating" type="radio" name="rating_desktop" value="4" />
                <label for="rating_4" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-40">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">4</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_3" v-model="filterRating" type="radio" name="rating_desktop" value="3" />
                <label for="rating_3" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-30">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">3</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_2" v-model="filterRating" type="radio" name="rating_desktop" value="2" />
                <label for="rating_2" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-20">
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">2</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_1" v-model="filterRating" type="radio" name="rating_desktop" value="1" />
                <label for="rating_1" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-10">
                        <span></span>
                      </div>
                      <span class="card-average-rating">1</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_0" v-model="filterRating" type="radio" name="rating_desktop" value="0" />
                <label for="rating_0" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform">
                        <span></span>
                      </div>
                      <span class="card-average-rating">0</span>
                    </div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
          <div v-if="options.category" class="section section--price">
            <h5 class="section__heading">Category</h5>
            <ul class="list">
              <li v-for="(item, idx) in categories" :key="idx" class="list__item-category">
                <input
                  :id="`category-${item._id}`"
                  v-model="filterCategory"
                  type="radio"
                  name="rating_category"
                  :value="item._id"
                />
                <label :for="`category-${item._id}`" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <span class="card-average-rating">{{ item.name }}</span>
                    </div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
    <div class="modal-footer">
      <a href="" class="btn btn-apply-filter btn-apply-filter-reset" @click.prevent="reset">Reset</a>
      <a href="" class="btn btn-apply-filter" @click.prevent="apply">Apply fiter</a>
    </div>
  </div>
</template>
<script>
/* eslint-disable vue/prop-name-casing */
import zenscroll from 'zenscroll';
// import FilterByBeautyProfile from '@/components/global/filter-by-beauty-profile/filter-by-beauty-profile';
export default {
  name: 'modal-filter-v2',
  components: {
    // FilterByBeautyProfile,
  },
  props: {
    list_brands: {
      required: false,
      type: Array,
      default: () => [],
    },
    list_country: {
      required: false,
      type: Array,
      default: () => [],
    },
    brand_detail: {
      required: false,
      type: Object,
      default: () => {},
    },
    categories: {
      required: false,
      type: Array,
      default: () => [],
    },
    options: {
      required: false,
      type: Object,
      default: () => {
        return { available: true, brands: true, rating: true, category: true };
      },
    },
  },
  data() {
    return {
      isEmptyWhenTypingBrand: false,
      selectedBrand: [],
      selectedOrigin: [],
      listsBrandsFinals: [],
      listsOriginsFinals: [],
      brandSearchName: '',
      brandSearch: '',
      clickedBrand: '',
      seeAllBrands: false,
      searchText: '',
      availibility: ['is_active_in_sociolla', 'is_active_in_lulla'],
      filterRating: '',
      filterAvailChecked: [],
      valueForQueryString: {
        brand_id: '',
        filter_rating: '',
        available_for: '',
      },
      activeTab: 0,
      selectedBeuatyProfile: [],
      filterCategory: '',
      availabitiesLabel: (option) => {
        switch (option) {
          case 'is_active_in_lulla':
            return 'Available at Lilla';
          case 'is_active_in_sociolla':
            return 'Available at Sociolla';
          default:
            return option;
        }
      },
    };
  },
  computed: {
    query() {
      return this.$route.query.query;
    },
    queryString() {
      return this.$store.state.$_Review.queryString;
    },
    showModalFilterV2() {
      return this.$store.state.modal.isModalShow.filterV2;
    },
    screen() {
      return this.$store.state.screen;
    },
    brandId() {
      return this.$route.params.brand_id;
    },
    brand_name() {
      return this.$route.params.brand_name;
    },
    originId() {
      return this.$route.params.origins;
    },
    categoryIdParam() {
      return Number(this.$route.params.category_id);
    },
    categoryNameParam() {
      return this.$route.params.category_name;
    },
    listSelectedBrand() {
      const filterBrands = [];
      const filterOrigins = [];
      this.listsBrandsFinals.forEach((brand) => {
        if (this.selectedBrand.includes(brand['_id'])) {
          filterBrands.push(brand);
        }
      });
      this.listsOriginsFinals.forEach((origin) => {
        const labelString = origin['country_tag_id'].toString() || '';
        if (this.selectedOrigin.includes(labelString)) {
          filterOrigins.push(origin);
        }
      });
      if (this.activeTab === 0) {
        return {
          brand: filterBrands,
          origin: filterOrigins,
          active: filterBrands,
        };
      } else {
        return {
          brand: filterBrands,
          origin: filterOrigins,
          active: filterOrigins,
        };
      }
    },
    filteredBrands() {
      let brands = this.listsBrandsFinals;
      if (this.activeTab === 1) {
        brands = this.listsOriginsFinals;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isEmptyWhenTypingBrand = false;
      if (this.brandSearch && this.brandSearch.toString().length) {
        const newBrand = brands.filter((brand) => {
          return this.brandSearch
            .toString()
            .toLowerCase()
            .split(' ')
            .every((v) => brand.name.toLowerCase().includes(v));
        });
        if (!newBrand.length) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isEmptyWhenTypingBrand = true;
        }
        return newBrand;
      } else {
        return brands;
      }
    },
    letters() {
      const letters = {
        '#': { isActive: false },
        a: { isActive: false },
        b: { isActive: false },
        c: { isActive: false },
        d: { isActive: false },
        e: { isActive: false },
        f: { isActive: false },
        g: { isActive: false },
        h: { isActive: false },
        i: { isActive: false },
        j: { isActive: false },
        k: { isActive: false },
        l: { isActive: false },
        m: { isActive: false },
        n: { isActive: false },
        o: { isActive: false },
        p: { isActive: false },
        q: { isActive: false },
        r: { isActive: false },
        s: { isActive: false },
        t: { isActive: false },
        u: { isActive: false },
        v: { isActive: false },
        w: { isActive: false },
        x: { isActive: false },
        y: { isActive: false },
        z: { isActive: false },
      };
      const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
      let key = 'name';
      if (this.activeTab === 1) {
        key = 'country';
      }
      this.filteredBrands
        .filter((item) => !item['isHidden'])
        .forEach((item) => {
          const firstChar =
            item[key][0] == ' ' ? item[key].replace(' ', '')[0].toLowerCase() : item[key][0].toLowerCase();
          const isAlpha = isAlphabet(firstChar);
          if (isAlpha) {
            letters[firstChar]['isActive'] = true;
          } else {
            letters['#']['isActive'] = true;
          }
        });
      return letters;
    },
    isProductMatchCategory() {
      return this.$route.name === 'ProductMatchCategory';
    },
    isOurCurated() {
      return this.$route.name === 'OurCuratedSelections';
    },
    beautyProfile() {
      if (this.isProductMatchCategory) {
        const user = this.$store.state.auth.userProfile;
        if (user && user.beauty) {
          const tags = [];
          user.beauty.forEach((item) => {
            item.subtags.forEach((item2) => tags.push(item2));
          });
          return tags;
        }
      }
      return [];
    },
    urlPage() {
      if (this.isProductMatchCategory) {
        return `/our-curated-selections/${this.categoryIdParam}`;
      } else if (this.isOurCurated) {
        return `/our-curated-selections`;
      } else {
        return `/category/${this.categoryIdParam}/${this.categoryNameParam}`;
      }
    },
  },
  watch: {
    'list_brands.length': {
      immediate: true,
      handler: function (length) {
        if (length && this.listsBrandsFinals.length === 0) {
          // eslint-disable-next-line vue/no-mutating-props
          const brands = JSON.parse(JSON.stringify(this.list_brands));
          this.listsBrandsFinals = brands.sort((a, b) => {
            return (a['name'] || '').localeCompare(b['name'] || '');
          });
        }
      },
    },
    'list_country.length': {
      immediate: true,
      handler: function (length) {
        if (length && this.listsOriginsFinals.length === 0) {
          // eslint-disable-next-line vue/no-mutating-props
          const countries = JSON.parse(JSON.stringify(this.list_country));
          this.listsOriginsFinals = countries.sort((a, b) => {
            return (a['country'] || '').localeCompare(b['country'] || '');
          });
        }
      },
    },
    seeAllBrands(newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          this.$refs['typeBrand'].focus();
        });
      }
    },
    $route(to, from) {
      if (this.$route.query) {
        if (this.$route.query.brands) {
          this.selectedBrand = this.$route.query.brands.split(',');
        }

        if (this.$route.query.origins) {
          this.selectedOrigin = this.$route.query.origins.split(',');
        }

        if (this.$route.query.available_for) {
          this.filterAvailChecked = this.$route.query.available_for.split(',');
        }

        if (this.$route.query.rating) {
          this.filterRating = this.$route.query.rating;
        }

        if (this.$route.query.category) {
          this.filterCategory = this.$route.query.category;
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch('$_Review/serialize', this.$route.query);
    if (this.$route.query) {
      if (this.$route.query.brands) {
        this.selectedBrand = this.$route.query.brand.split(',');
      }
      if (this.$route.query.origins) {
        this.selectedOrigin = this.$route.query.origins.split(',');
      }

      if (this.$route.query.available_for) {
        this.filterAvailChecked = this.$route.query.available_for.split(',');
      }

      if (this.$route.query.rating) {
        this.filterRating = this.$route.query.rating;
      }
      if (this.$route.query.beauty) {
        this.selectedBeuatyProfile = this.$route.query.beauty.split(',');
      }
      if (this.$route.query.category) {
        this.filterCategory = this.$route.query.category;
      }
    }
  },
  beforeDestroy() {
    this.listsBrandsFinals.forEach((brand) => (brand['isHidden'] = false));
  },
  methods: {
    checkActiveTab() {
      if (this.activeTab === 0) {
        return this.list_brands;
      }
      if (this.activeTab === 1) {
        return this.list_country;
      }
    },
    buildIdElBrand(brand, idx) {
      const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
      let list = 'listsBrandsFinals';
      let key = 'name';
      if (this.activeTab === 1) {
        list = 'listsOriginsFinals';
        key = 'country';
      }
      const prevBrand = idx > 0 ? this[list][idx - 1] : null;
      const brandFirstChar = brand[key][0].toLowerCase();
      const isAlpha = isAlphabet(brandFirstChar);

      if (isAlpha) {
        if (prevBrand !== null && prevBrand[key][0].toLowerCase() !== brandFirstChar) {
          return 'brand-' + brandFirstChar;
        }
      } else if (!isAlpha && prevBrand === null) {
        return 'brand-#';
      }

      return '';
    },
    setSelectedOrigin(brand) {
      this.selectedOrigin.push(brand.country_tag_id.toString());
    },
    checkSameQueryParams(a, b) {
      const obj_1 = Object.getOwnPropertyNames(a);
      const obj_2 = Object.getOwnPropertyNames(b);

      if (obj_1.length != obj_2.length) {
        return false;
      }

      for (let i = 0; i < obj_1.length; i++) {
        const attr = obj_1[i];
        if (a[attr] !== b[attr]) {
          return false;
        }
      }

      return true;
    },
    applyBrand() {
      let brandQuery = '';
      brandQuery = this.selectedBrand.join();
      if (this.selectedBrand && this.selectedBrand.length) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'brands',
          value: brandQuery,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'brands',
          value: '',
        });
      }
    },
    applyOrigin() {
      let brandQuery = '';
      brandQuery = this.selectedOrigin.join();
      if (this.selectedOrigin && this.selectedOrigin.length) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'origins',
          value: brandQuery,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'origins',
          value: '',
        });
      }
    },
    applyRating() {
      if (this.filterRating) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'rating',
          value: this.filterRating,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'rating',
          value: '',
        });
      }
    },
    applyAvailable() {
      const availableQuery = this.filterAvailChecked.join();
      if (this.filterAvailChecked) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'available_for',
          value: availableQuery,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'available_for',
          value: '',
        });
      }
    },
    applyCategory() {
      const categoryQuery = this.filterCategory;
      if (this.filterCategory) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'category',
          value: categoryQuery,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'category',
          value: '',
        });
      }
    },
    apply() {
      this.applyBrand();
      this.applyAvailable();
      this.applyOrigin();
      this.applyRating();
      this.applyCategory();
      let query = Object.assign({}, this.$route.query);

      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'skip',
        value: 0,
      });

      if (this.queryString.category) {
        query = Object.assign(query, { category: this.queryString.category });
      } else {
        if (query.category) {
          delete query.category;
        }
      }

      if (this.queryString.available_for) {
        query = Object.assign(query, { available_for: this.queryString.available_for });
      } else {
        if (query.available_for) {
          delete query.available_for;
        }
      }

      if (this.queryString.origins) {
        query = Object.assign(query, { origins: this.queryString.origins });
      } else {
        if (query.origins) {
          delete query.origins;
        }
      }

      if (this.queryString.brands) {
        query = Object.assign(query, { brands: this.queryString.brands });
      } else {
        if (query.brands) {
          delete query.brands;
        }
      }

      if (this.queryString.rating) {
        query = Object.assign(query, { rating: this.queryString.rating });
      } else {
        if (query.rating) {
          delete query.rating;
        }
      }

      if (query.page) {
        query.page = 1;
      }

      if (!this.checkSameQueryParams(this.$route.query, query)) {
        this.$router.push({ query: query });
      }
      this.closeModal();
    },
    onKeyupSearchbrand(e) {
      let list = 'listsBrandsFinals';
      let keys = 'name';
      if (this.activeTab === 1) {
        list = 'listsOriginsFinals';
        keys = 'country';
      }

      const value = e.target.value.toLowerCase();
      const totalBrands = this[list].length;
      let i = 0;

      if (value.length > 0) {
        this.seeAllBrands = true;
      } else {
        this.seeAllBrands = false;
      }

      this.brandSearchName = value;
      this[list].forEach((brand, key) => {
        const brandNameToLowerCase = brand[keys].toLowerCase();

        if (brandNameToLowerCase.includes(value)) {
          this.$set(this[list][key], 'isHidden', false);
        } else {
          this.$set(this[list][key], 'isHidden', true);
          i++;
        }
      });

      this.isEmptyWhenTypingBrand = i === totalBrands;
    },
    scrollToBrandMenu(item) {
      const defaultDuration = 400;
      const edgeOffset = 0;
      const myDiv = document.getElementById('brand-list-by-filter');
      const myScroller = zenscroll.createScroller(myDiv, defaultDuration, edgeOffset);
      const char = item.split('-').splice(1, 1)[0];
      const newElm = document.getElementsByClassName('for-br-' + char)[0];

      this.$set(this, 'clickedBrand', char);

      myScroller.toY(newElm.offsetTop - 100);
    },
    removeSelectedBrand(key, activeTab) {
      if (activeTab === 0) {
        this.selectedBrand.splice(key, 1);
      }
      if (activeTab === 1) {
        this.selectedOrigin.splice(key, 1);
      }
    },
    reset() {
      this.filterRating = '';
      this.filterAvailChecked = [];
      this.selectedBrand = [];
      this.selectedOrigin = [];
      this.selectedBeuatyProfile = [];
      if (this.$refs.beauty) {
        this.$refs.beauty.reset();
      }
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'category',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'brands',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'origins',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'available_for',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'rating',
        value: '',
      });

      if (
        this.$route.name == 'Category' ||
        this.$route.name == 'ProductMatchCategory' ||
        this.$route.name == 'OurCuratedSelections'
      ) {
        this.$router.push(`${this.urlPage}`);
      } else if (this.$route.name == 'Search') {
        this.$router.push(`/search?query=${this.query}`);
      } else if (this.$route.name == 'BrandDetailOrigin') {
        this.$router.push(`/brand/${this.brandId}-${this.$options.filters.slug(this.brand_detail.data.country)}`);
      } else if (this.$route.name == 'BrandDetail') {
        this.$router.push(`/brand/${this.brandId}/${this.brand_name}`);
      } else {
        this.$router.push();
      }
    },
    closeModal() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'filterV2',
      });
    },
    onFocusShowAllBrands() {
      if (!this.seeAllBrands && this.brandSearchName.length > 0) {
        this.seeAllBrands = true;
      }
    },
    showAllBrands() {
      this.seeAllBrands = true;
    },
    selectedBeauty(selected) {
      this.selectedBeuatyProfile = [...selected];
    },
  },
};
</script>
<style lang="scss" scoped>
@import './_modal-filter';
</style>
